import { ZfCard, ZfCardContent, ZfStack, ZfTypography } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { formatAmount } from '../../../../utils/renderUtils';

interface IAssetGroupChartTabProps {
    id: number;
    currency?: string;
    amount: number;
    subTitle: string;
    isActive: boolean;
    onTabSelect: () => void;
}

export const AssetGroupChartTab: FunctionComponent<IAssetGroupChartTabProps> = ({ id, currency, amount, subTitle, isActive, onTabSelect }) => (
    <ZfCard key={id} selectable={true} selected={isActive} onCardSelect={onTabSelect}>
        <ZfCardContent className="wealth-overview__chart-tab-button" style={{ justifyContent: 'center' }}>
            <ZfStack style={{ maxWidth: '148px', marginTop: '6px', marginLeft: '6px' }}>
                <ZfTypography variant="body-large">
                    {currency} {formatAmount(amount)}
                </ZfTypography>
                <ZfTypography variant="label-small" color="normal" noWrap={true} style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>
                    {subTitle}
                </ZfTypography>
            </ZfStack>
        </ZfCardContent>
    </ZfCard>
);
